import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  paddingBottom: theme.spacing(6.625),
  [theme.breakpoints.down('lg')]: {
    paddingBottom: theme.spacing(4),
  },
  [theme.breakpoints.down('md')]: {
    paddingBottom: theme.spacing(3),
  },
  '& .TACSTitle': {
    color: theme.palette.grey[800],
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  '& .TACSDesc': {
    color: theme.palette.secondary.main,
    marginBottom: theme.spacing(3),
  },
  '& .TACSTabsSection': {
    position: 'relative',
    '&::before': {
      content: '""',
      borderBottom: `1px solid ${theme.palette.grey[200]}`,
      position: 'absolute',
      width: '100%',
      bottom: 0,
    },
  },
  '& .TACSTabs': {
    minHeight: 'unset',
    position: 'relative',
    bottom: '-1px',
    '& .MuiTabScrollButton-root': {
      display: 'none',
    },
    '& .MuiTab-root': {
      borderBottom: '0px',
      minWidth: 'unset',
      minHeight: 'unset',
      color: theme.palette.grey[300],
      letterSpacing: '0.105px',
      fontWeight: 400,
      padding: theme.spacing(0, 1, 1, 1),
      marginRight: theme.spacing(1),
      '&.Mui-selected': {
        borderBottom: ` 1px solid ${theme.palette.primary.main}`,
        color: theme.palette.primary.main,
        cursor: 'text',
        pointerEvents: 'unset',
        fontWeight: 500,
      },
    },
    '& .MuiTouchRipple-root': {
      display: 'none',
    },
    '& .MuiTabs-indicator ': {
      display: 'none',
    },
  },
}));

export default StyledBox;
